import React, { useEffect } from 'react'
import FAQ from './FAQ'
import { Link } from "react-router-dom";
import { Button } from 'antd';

export default function Audiobook(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Proof Listen to Audiobooks";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/shutterstock_1735767839_600.jpg'}
                    srcSet={`/images/shutterstock_1735767839_1200.jpg 4000w`}
                    alt="Audiobooks"
                    style={{float: 'left', width: '100%'}}
                />
                <div className="header-text">
                    <header>
                        <h1>Proof Listen to Audiobook</h1>
                    </header>
                    <p>
                        Just like every book needs to be proofread, so does every audiobook. Proof listening to an audiobook helps make sure that the potential listeners of the audiobook have a pleasant experience. Moreover, I have done a Grade 5 reading exam with The London Academy of Music and Dramatic Arts (LAMDA). This makes me well qualified to make informed suggestions of where tonal variations, pauses should be implemented and of course, flagging if there are any word(s)/ sentence(s) omissions from the original manuscript or mispronunciations.
                    </p>
                    <Link to="/request?service=audiobook"><Button type="primary">Request to proof listen</Button></Link>
                </div>
            </div>

            <div className="content-wrapper">
                <FAQ topic='audiobook' />
                <FAQ topic='general' />
            </div>
        </div>
    )
}
